import { formatFileSize } from "@/services/documentService";

interface FileSizeDisplayProps {
  size: number;
  className?: string;
}

export const FileSizeDisplay = ({ size, className }: FileSizeDisplayProps) => {
  return <span className={className}>{formatFileSize(size)}</span>;
};
